import { render, staticRenderFns } from "./HistoricalAgent.vue?vue&type=template&id=f1ca59d2&"
import script from "./HistoricalAgent.vue?vue&type=script&lang=ts&"
export * from "./HistoricalAgent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HistoricalAgent.vue"
export default component.exports